<template>
  <div :class="`${element.isLock ? 'wrap' : 'wrap cursor'} ${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles({...element.compData.styles, wrapHeight: element.boxStyle.height})}"
  >
    <List size="small" :style="{'overflow': element.compData.isScroll ? 'hidden' : 'auto'}">
      <div v-if="!element.compData.isScroll" @click="handleClick($event)">
        <ListItem v-for="(item,index) in element.compData.data.data" :key="index">
          <span v-if="element.compData.showIndex">{{index + 1}}.&nbsp;&nbsp;</span>
          <span :data-obj="JSON.stringify(item)">{{item.title}}</span>
        </ListItem>
      </div>
      <div v-if="element.compData.isScroll" @click="handleClick($event)">
        <VueSeamlessScroll :data="element.compData.data.data" class="seamless-warp" :class-option="classOption">
          <ListItem v-for="(item,index) in element.compData.data.data" :key="index">
            <span v-if="element.compData.showIndex">{{index + 1}}.&nbsp;&nbsp;</span>
            <span :data-obj="JSON.stringify(item)">{{item.title}}</span>
          </ListItem>
        </VueSeamlessScroll>
      </div>
    </List>
  </div>
</template>

<script>
import { List} from 'view-design'
import VueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "ListElement",
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    },
    classOption () {
      return {
        autoPlay: true,
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.element.compData.data.data.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: parseInt(this.element.compData.scrollType), // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 100 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    handleClick(ev) {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onclick',
        eventData: {
          value: JSON.parse(ev.target.dataset.obj || '{}'),
          data: this.plugin,
          event: null
        }
      })
    },
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return Object.assign(res, {
        opacity: this.element["opacity"] / 100
      })
    }
  },
  mounted () {
    this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: null,
        data: this.plugin,
        event: null
      }
    })
  },
  components: {
    List,
    ListItem: List.Item,
    VueSeamlessScroll
  }
};
</script>

<style lang='less' scoped>
.seamless-warp{
  width: var( --width );
  height: var( --height );
  overflow: hidden;
}
.ivu-list-items li {
  font-size: var( --bodyFontSize);
  color: var( --bodyFontColor);
  font-family: var(--bodyFontFamily) !important;
  overflow: hidden;
  text-overflow:ellipsis;
  height: var( --bodyHeigth);
  border-bottom-color: var(--bottomColor);
  padding-left: 10px;
  cursor: pointer;
  // border-bottom:0;
  span {
    font-family: var(--bodyFontFamily) !important;
  }
}
.ivu-list-items li:nth-child(2n) {
  background-color: var( --bodyevenBgColor);
}
.ivu-list-items li:nth-child(2n-1) {
  background-color: var( --bodyoldBgColor);
}
.wrap {
  width: 100%;
  height: 100%;
}

/deep/.ivu-list {
    width:100%;
    height: calc( var( --wrapHeight) );
    overflow-y: auto;
    overflow-x: hidden;
    // border-radius: 0 0 20px 20px;
    /*定义滚动条样式（高宽及背景）*/
    &::-webkit-scrollbar {
        width: 10px;
        height: 1px;
        background:  rgba(255, 255, 255, 0.3);
    }
    /*定义滚动条轨道（凹槽）样式*/
    &::-webkit-scrollbar-track {
      display: none;
      border-radius: 10px;

    }
    /*定义滑块 样式*/
    &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: var( --listBarColor);
    }
}
</style>
